import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import authentication from "./routerServices";

const Routes = () => (
    <Router>
      <Switch>
        <Route path="" render={(e) => authentication(true)} />
      </Switch>
    </Router>
);

export default Routes;
